var $52535c35c24ec937$exports = {};
$52535c35c24ec937$exports = {
  "ascending": "\uC624\uB984\uCC28\uC21C",
  "ascendingSort": function ascendingSort(args) {
    return "".concat(args.columnName, " \uC5F4\uC744 \uAE30\uC900\uC73C\uB85C \uC624\uB984\uCC28\uC21C\uC73C\uB85C \uC815\uB82C\uB428");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " \uD53D\uC140");
  },
  "descending": "\uB0B4\uB9BC\uCC28\uC21C",
  "descendingSort": function descendingSort(args) {
    return "".concat(args.columnName, " \uC5F4\uC744 \uAE30\uC900\uC73C\uB85C \uB0B4\uB9BC\uCC28\uC21C\uC73C\uB85C \uC815\uB82C\uB428");
  },
  "resizerDescription": "\uD06C\uAE30 \uC870\uC815\uC744 \uC2DC\uC791\uD558\uB824\uBA74 Enter\uB97C \uB204\uB974\uC138\uC694.",
  "select": "\uC120\uD0DD",
  "selectAll": "\uBAA8\uB450 \uC120\uD0DD",
  "sortable": "\uC815\uB82C \uAC00\uB2A5\uD55C \uC5F4"
};
export { $52535c35c24ec937$exports as default };